import styled from '@emotion/styled';
import {
    Button,
    ButtonGroup,
    Form,
    FormInputTextarea,
    HeadingText30,
    HeadingText60,
    pxToRem,
    useForm,
} from '@modernhealth/vital-components';
import React from 'react';
import { useTranslation } from 'react-i18next';

const Wrapper = styled.div({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 auto',
    maxWidth: pxToRem(570),
    maxHeight: pxToRem(1000),
});

interface Props {
    onSubmit: (text: string) => void;
    onBackClick: () => void;
}
const textAreaFieldName = 'localTherapyRequest';

type FormData = {
    [textAreaFieldName]: string;
};

export const LocalTherapyRequest: React.FC<Props> = ({ onSubmit, onBackClick }) => {
    const { t } = useTranslation();

    const formDefinition = useForm<FormData>({});

    const { isSubmitting } = formDefinition.formState;

    const handleSubmit = values => {
        onSubmit(values[textAreaFieldName]);
    };

    return (
        <Wrapper>
            <Form definition={formDefinition} onSubmit={handleSubmit}>
                <HeadingText60 centered>{t('providers:local_therapy.title')}</HeadingText60>
                <HeadingText30 centered fontColor="gray40">
                    {t('providers:local_therapy.description.1')}
                </HeadingText30>

                <HeadingText30 centered fontColor="gray40">
                    {t('providers:local_therapy.description.2')}
                </HeadingText30>

                <FormInputTextarea
                    name={textAreaFieldName}
                    label={t('providers:local_therapy.anything_else')}
                    rows={5}
                    trim
                />

                <ButtonGroup>
                    <Button onClick={onBackClick} variant="secondary">
                        {t('common.back')}
                    </Button>
                    <Button busy={isSubmitting} type="submit" variant="primary">
                        {t('common.continue')}
                    </Button>
                </ButtonGroup>
            </Form>
        </Wrapper>
    );
};
